import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import WEB from "../assets/images/services-dev.jpg";
import POS from "../assets/images/services-pos.jpg";
import IOT from "../assets/images/services-iot.jpg";
import CLOUD from "../assets/images/services-cloud.jpg";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false,

      token: "",
    };
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />
        {/* SECTION 1 HERO */}
        <div className="w-100 text-white position-relative" 
        style={{ 
          minHeight: 600, 
          backgroundImage: `url(${require("../assets/images/hero-background.jpg")})`, 
          backgroundSize: "cover", 
          backgroundPosition: "center", 
          backgroundRepeat: "no-repeat"
        }}>
          <div className="align-content-center" style={{ minHeight: 600, background: "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0.3), rgba(0,0,0,0))" }}>
          <div className="row container mx-auto">
            <div className="col-12 col-md-8 col-xl-6 p-0">
              <div className="px-4 mx-auto">
                <h1 className="fw-bold mb-2">เราช่วยสร้าง</h1>
                <h1 className="fw-bold mb-2">นวัตกรรมดิจิทัล</h1>
                <h1 className="fw-bold mb-3">ให้ธุรกิจของคุณเติบโต</h1>
                <h5 className="mb-3">ทีมพัฒนามืออาชีพ ครบวงจร ทั้ง Web, Mobile, POS และ IoT</h5>
                <div className="d-flex flex-wrap">
                <a className="btn btn-light px-5 me-2 mb-2" href="/contact">ติดต่อเรา</a>
                <a className="btn btn-light px-4 me-2 mb-2" href="/contact?subject=ขอใบเสนอราคา">ขอใบเสนอราคา</a>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-light">
          <div className="container mx-auto p-5 text-center">
            <h1 className="fw-bold mb-4">ระบบธุรกิจ (Business System Analysis)</h1>
            <div className="text-secondary mb-5">เราวิเคราะห์และออกแบบระบบให้เหมาะสมกับธุรกิจของคุณ เพื่อเพิ่มประสิทธิภาพและลดต้นทุนการดำเนินงาน</div>
            <div className="row">
              <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf200"}</span>
                  <h5 className="fw-bold mb-3">วิเคราะห์ธุรกิจ</h5>
                  <span className="text-secondary">วิเคราะห์กระบวนการทำงานและหาจุดที่สามารถพัฒนาได้</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf085"}</span>
                  <h5 className="fw-bold mb-3">ออกแบบระบบ</h5>
                  <span className="text-secondary">ออกแบบระบบที่เหมาะสมและรองรับการเติบโตในอนาคต</span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                <div className="card card-dashboard rounded-3 bg-white p-3 border-1" style={{ minHeight: 212 }}>
                  <span className="icon text-60 text-primary">{"\uf061"}</span>
                  <h5 className="fw-bold mb-3">ปรับปรุงอย่างต่อเนื่อง</h5>
                  <span className="text-secondary">ติดตามและปรับปรุงระบบให้ทันสมัยและมีประสิทธิภาพ</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="w-100 bg-white align-content-center">
          <div className="container px-4 my-5 text-center">
            <h1 className="fw-bold mb-4">พัฒนา Web App, Mobile App, POS และ IoT</h1>
            <div className="text-secondary">ทีมผู้เชี่ยวชาญของเราพร้อมพัฒนาโซลูชันที่ตอบโจทย์ธุรกิจของคุณ</div>
          </div>
          {/* BLOCK 1 */}
          <div className="row container mx-auto my-5">
            <div className="col-12 col-md-6 p-0 align-content-center">
              <div className="px-4 mx-auto">
                <h2 className="fw-bold mb-4">Web & Mobile Application Development</h2>
                <div className="mb-3">ในยุคดิจิทัลที่ธุรกิจต้องปรับตัวอย่างรวดเร็ว การมีระบบที่ตอบโจทย์และสามารถขยายตัวได้ตามกลยุทธ์องค์กรเป็นสิ่งสำคัญ ทีมของเราพร้อมให้บริการครบวงจร ตั้งแต่การวิเคราะห์ระบบธุรกิจ วางแผนกลยุทธ์เทคโนโลยี ไปจนถึงการออกแบบ พัฒนา และดูแลรักษาระบบต่างๆ เพื่อให้คุณโฟกัสที่ธุรกิจของคุณได้เต็มที่</div>
              </div>
            </div>
            <div className="col-12 col-md-6 p-0">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="WEB" src={WEB} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
          </div>
          {/* BLOCK 2 */}
          <div className="row container mx-auto my-5">
            <div className="col-12 col-md-6 p-0 d-none d-md-block">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="POS" src={POS} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
            <div className="col-12 col-md-6 p-0 align-content-center">
              <div className="px-4 mx-auto">
                <h2 className="fw-bold mb-4">Point-of-Sale (POS) System</h2>
                <div className="mb-3">ในยุคดิจิทัลที่ธุรกิจต้องปรับตัวอย่างรวดเร็ว การมีระบบที่ตอบโจทย์และสามารถขยายตัวได้ตามกลยุทธ์องค์กรเป็นสิ่งสำคัญ ทีมของเราพร้อมให้บริการครบวงจร ตั้งแต่การวิเคราะห์ระบบธุรกิจ วางแผนกลยุทธ์เทคโนโลยี ไปจนถึงการออกแบบ พัฒนา และดูแลรักษาระบบต่างๆ เพื่อให้คุณโฟกัสที่ธุรกิจของคุณได้เต็มที่</div>
              </div>
            </div>
            <div className="col-12 col-md-6 p-0 d-block d-md-none">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="POS" src={POS} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
          </div>
          {/* BLOCK 3 */}
          <div className="row container mx-auto my-5">
            <div className="col-12 col-md-6 p-0 align-content-center">
              <div className="px-4 mx-auto">
                <h2 className="fw-bold mb-4">IoT Solutions เชื่อมต่อโลกธุรกิจกับฮาร์ดแวร์อย่างลงตัว</h2>
                <div className="mb-3">ในยุคดิจิทัลที่ธุรกิจต้องปรับตัวอย่างรวดเร็ว การมีระบบที่ตอบโจทย์และสามารถขยายตัวได้ตามกลยุทธ์องค์กรเป็นสิ่งสำคัญ ทีมของเราพร้อมให้บริการครบวงจร ตั้งแต่การวิเคราะห์ระบบธุรกิจ วางแผนกลยุทธ์เทคโนโลยี ไปจนถึงการออกแบบ พัฒนา และดูแลรักษาระบบต่างๆ เพื่อให้คุณโฟกัสที่ธุรกิจของคุณได้เต็มที่</div>
              </div>
            </div>
            <div className="col-12 col-md-6 p-0">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="IOT" src={IOT} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
          </div>
           {/* BLOCK 4 */}
          <div className="row container mx-auto my-5">
            <div className="col-12 col-md-6 p-0 d-none d-md-block">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="POS" src={CLOUD} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
            <div className="col-12 col-md-6 p-0 align-content-center">
              <div className="px-4 mx-auto">
                <h2 className="fw-bold mb-4">Cloud, Data, DevOps และ Security Services</h2>
                <div className="mb-3">บริการโครงสร้างพื้นฐานคลาวด์ที่มั่นคงและปลอดภัย</div>
              </div>
            </div>
            <div className="col-12 col-md-6 p-0 d-block d-md-none">
              <div className="w-75 hpx-400 bg-white mx-auto">
                <img alt="POS" src={POS} className="h-100 w-100 rounded-3" style={{ objectFit: "cover" }} />
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 4 */}
        <div className="w-100 bg-gray align-content-center">
          <div className="container px-4 my-5 text-center">
            <h1 className="fw-bold mb-4">Cloud, Data, DevOps และ Security Services</h1>
            <div className="text-secondary">เรามีบริการสนับสนุนด้านโครงสร้างพื้นฐานระบบที่สำคัญในยุคดิจิทัล เช่น</div>
          </div>
          <div className="row container mx-auto my-5">
            <div className="col-12 col-md-6 col-xl-3 p-0">
              <div className="px-4 mx-auto text-center">
                 <span className="icon text-60 text-primary">{"\uf744"}</span>
                <h4 className="fw-bold mb-4 hpx-50">Cloud Infrastructure & Migration</h4>
                <div className="mb-3">AWS, GCP, Azure, DigitalOcean ฯลฯ</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 p-0">
              <div className="px-4 mx-auto text-center">
                 <span className="icon text-60 text-primary">{"\uf201"}</span>
                <h4 className="fw-bold mb-4 hpx-50">Data Platform & Analytics</h4>
                <div className="mb-3">Data Lake, Real-time Dashboard, BigQuery</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 p-0">
              <div className="px-4 mx-auto text-center">
                 <span className="icon text-60 text-primary">{"\uf37e"}</span>
                <h4 className="fw-bold mb-4 hpx-50">DevOps & CI/CD Pipeline</h4>
                <div className="mb-3">GitHub Actions, Docker, Kubernetes, Terraform</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 p-0">
              <div className="px-4 mx-auto text-center">
                 <span className="icon text-60 text-primary">{"\uf505"}</span>
                <h4 className="fw-bold mb-4 hpx-50">Cybersecurity Consulting</h4>
                <div className="mb-3">Zero Trust, API Security, Penetration Testing</div>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 6 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">ปรึกษาเราฟรีวันนี้</h1>
              <div className="mb-3">เราพร้อมรับฟังความต้องการของคุณ วิเคราะห์ปัญหาอย่างตรงจุด และเสนอแนวทางที่เหมาะสมกับองค์กรของคุณมากที่สุด</div>
              <div className="mb-4">ให้เทคโนโลยีขับเคลื่อนธุรกิจของคุณ — ไปพร้อมกับเรา</div>
              <div className="d-flex justify-content-center flex-wrap">
              <a className="btn btn-light px-5 mx-1 mb-2" href="/contact?subject=นัดหมายปรึกษา">นัดหมายปรึกษา</a>
              <a className="btn btn-light px-5 mx-1 mb-2" href="/contact">ติดต่อเรา</a>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
